(function($, window, undefined) {
  	var trackingNumber;
  	var monthNames = [
        "Enero", "Febrero", "Marzo",
        "Abril", "Mayo", "Junio", "Julio",
        "Augosto", "Septiembre", "Octubre",
        "Noviembre", "Diciembre"
    ];
    function formatCompleteDate(date) {
      	if (date) {
          	var dateS = date.toString();
          	if (dateS.toLowerCase().match(/[a-z]/i)) {
              	// If date is ISO formatted
              	var datestr = date.split(/[-T.]/);
                var safdat = new Date( datestr.slice(0,3).join('/')+' '+datestr[3] );
                var FormattedDate = new Date(safdat);
                var day = FormattedDate.getDate();
                var monthIndex = FormattedDate.getMonth();
                var year = FormattedDate.getFullYear();
                var hour = FormattedDate.getHours();
              	hour = '0' + hour;
                hour = hour.slice(-2);
                var min = FormattedDate.getMinutes();
              	min = '0' + min;
                min = min.slice(-2);
                return day + ' ' + monthNames[monthIndex] + ' ' + year + ' a las ' + hour + ':' + min ;
            } else {
              	// If date is TimeStamp
              	var preFormattedDate = new Date(date).toISOString();
				var datestr = preFormattedDate.split(/[-T.]/);
                var safdat = new Date( datestr.slice(0,3).join('/')+' '+datestr[3] );
                var FormattedDate = new Date(safdat);
                var day = FormattedDate.getDate();
                var monthIndex = FormattedDate.getMonth();
                var year = FormattedDate.getFullYear();
                var hour = FormattedDate.getHours();
              	hour = '0' + hour;
                hour = hour.slice(-2);
                var min = FormattedDate.getMinutes();
              	min = '0' + min;
                min = min.slice(-2);
                return day + ' ' + monthNames[monthIndex] + ' ' + year + ' a las ' + hour + ':' + min ;
            }
        } else {
          	return '';
        }
    }
  	function formatSimpleDate(date) {
      	if(date) {
          	var dateS = date.toString();
          	if (dateS.toLowerCase().match(/[a-z]/i)) {
              	// If date is ISO formatted
              	var datestr = date.split(/[-T.]/);
                var safdat = new Date( datestr.slice(0,3).join('/')+' '+datestr[3] );
                var FormattedDate = new Date(safdat);
                var day = FormattedDate.getDate();
                var monthIndex = FormattedDate.getMonth();
                return day + ' ' + monthNames[monthIndex];
            } else {
              	// If date is TimeStamp
              	var preFormattedDate = new Date(date).toISOString();
				var datestr = preFormattedDate.split(/[-T.]/);
                var safdat = new Date( datestr.slice(0,3).join('/')+' '+datestr[3] );
                var FormattedDate = new Date(safdat);
                var day = FormattedDate.getDate();
                var monthIndex = FormattedDate.getMonth();
                return day + ' ' + monthNames[monthIndex];
            }
        } else {
          	return '';
        }
    }

    function parseShippingStatus(status) {
        switch(status) {
           	case 'ORDERED':
            	return 'Pedido'
            break;
            case 'IN_TRANSIT':
                return 'En tránsito'
            break;
            case 'PROCESSED':
                return 'Procesado'
            break;
            case 'SHIPPED':
                return 'Enviado'
            break;
            case 'DELIVERED':
                return 'Entregado'
            break;
            default: 'Estado desconocido';
        }
    }

  	function getLastStatusPosition(status) {
      	switch(status) {
          	case 'ORDERED':
            	return 0
            break;
            case 'PROCESSED':
                return 1
            break;
			case 'SHIPPED':
                return 2
            break;
          	case 'IN_TRANSIT':
                return 3
            break;
            case 'DELIVERED':
                return 4
            break;
            default: 'Unknown status';
        }
  	}

  	function dateTimeline(item, index) {
    	if(item.statusList[index]) {
      		return formatSimpleDate(item.statusList[i].events[0].eventDate)
      	}
      	return '';
    }

    function dateTimelineSoid(uniqueStatus, index) {
    	if(uniqueStatus[index]) {
      		return formatSimpleDate(uniqueStatus[index].date);
      	}
      	return '';
    }

  	/* Delivery companies functions */
  	function updateCompanyLinksByCountry(countryCode) {
      	var deliveryCompanies = {
            us: ['https://tools.usps.com/go/TrackConfirmAction?tLabels=--trackingNumber--'],
            au: ['https://auspost.com.au/mypost/track/#/details/--trackingNumber--'],
            gb: ['https://www.royalmail.com/track-your-item#/tracking-results/--trackingNumber--'],
            ca: ['https://www.canadapost.ca/cpotools/apps/track/personal/findByTrackNumber?execution=e3s1'],
            de: ['https://www.deutschepost.de/sendung/simpleQuery.html?locale=en_GB'],
            ar: ['https://www.correoargentino.com.ar/formularios/oidn'],
            mx: ['http://www.correosdemexico.gob.mx/ENGLISH/Paginas/track.aspx'],
            fr: ['https://www.laposte.fr/particulier/outils/suivre-vos-envois?code=--trackingNumber--'],
            br: ['http://www2.correios.com.br/sistemas/rastreamento/default.cfm'],
            ch: ['https://service.post.ch/EasyTrack/#simpleSearch'],
            it: ['https://www.poste.it/cerca/index.html#/risultati-cerca-nel-sito/--trackingNumber--'],
            il: ['https://www.israelpost.co.il/itemtrace.nsf/mainsearch?OpenForm&L=EN'],
            se: ['https://www.postnord.se/en/online-tools/tools/track/track-and-trace#dynamicloading=true&shipmentid=--trackingNumber--'],
            no: ['https://sporing.posten.no/sporing.html?q=--trackingNumber--&lang=en'],
            es: ['http://www.correos.es/ss/Satellite/site/aplicacion-4000003383089-herramientas_y_apps/detalle_app-sidioma=es_ES?numero=--trackingNumber--'],
            nl: ['http://www.postnl.post/tracktrace'],
            in: ['https://www.indiapost.gov.in/VAS/Pages/TrackConsignment.aspx'],
            cl: ['http://www.correos.cl/SitePages/seguimiento/seguimiento.aspx?envio=--trackingNumber--'],
            hk: ['https://www.hongkongpost.hk/en/mail_tracking/index.html', 'http://www.sf-express.com/hk/en/dynamic_function/waybill/'],
            nz: ['https://www.nzpost.co.nz/tools/tracking']
        };

      	var cCode;
        var counter;

      	if (countryCode in deliveryCompanies) {
          	$('#companiesLinks').html('');
            for (cCode in deliveryCompanies) {
                if (countryCode === cCode) {
                    for(counter in deliveryCompanies[cCode]) {
                        $('#companiesLinks').append('<a href="' + deliveryCompanies[cCode][counter].replace(/--trackingNumber--/g, trackingNumber) + '" target="_blank"><img src="http://d32tjqf3wflmk0.cloudfront.net/delivery-companies/' + countryCode + (counter > 0 ? '-' + counter : '') + '-logo.png"/></a>');
                    }
                }
            }
        }
  	}

  	function updateCountrySelect(countryCode) {
      	var countryOption = $('.option[data-value="' + countryCode + '"]');
      	var countryName = countryOption.attr('data-country');

      	if (countryName) {
        	$('.country-nice-select span.current span.text').text(countryName);
        	$('.country-nice-select span.current span.flags').removeClass().addClass('flags').addClass('flags-' + countryName);
      	}
  	}

	/* Main Functions */
    $(document).ready(function() {
      	var searchParams = new URLSearchParams('?' + window.location.href.split('?')[1]);

      	var oid = searchParams.get('oid');
      	var soid = searchParams.get('soid');
      	var email = searchParams.get('customerEmail');

      	if (soid) {
            var supplierOrderId = soid;
            var errorMessage = "Ooops, algo ha ido mal, por favor iténtelo de nuevo más tarde";
            var errorContainer = $('.tracking-wrapper .error');
            var currentStatusDate = "";
            var currentStatusTitle = "";
            var currentStatusDescription = "";
            var detailsContent = "";
          	var statusDates = [];
        	$(errorContainer).hide();
        	$.ajax({
          		async: false,
          		url: "https://gateway.ecommerce-wh.com/suppliers/shippingTrackings/search/findAllBySupplierOrderIdOrderByEventDateAsc?supplierOrderId=" + encodeURIComponent(decodeURIComponent(supplierOrderId))
            }).done(function(data) {
          		var shippings = data._embedded.shippingTrackings;
            	if (shippings.length == 0) {
            		errorMessage = "Ooops! Parece que la dirección no es válida";
            		errorContainer.show();
          		} else {
                  	shippings.forEach(function(shipping) {
                      	var currentStatus = {};
                      	currentStatus.status = shipping.status;
                      	currentStatus.date = formatSimpleDate(shipping.eventDate);
                      	statusDates.push(currentStatus);
                    });
                  	var uniqueStatus = [];
                  	var orderDate = '';
                  	var processDate = '';
                  	var shipDate = '';
                  	var transitDate = '';
                  	var deliverDate = '';
                  	$.each(statusDates, function (i, e) {
                        var matchingItems = $.grep(uniqueStatus, function (item) {
                           return item.status === e.status && item.date === e.date;
                        });
                        if (matchingItems.length === 0){
                            uniqueStatus.push(e);
                        }
                    });
                  	$.each(uniqueStatus, function (i, e) {
                       	switch(uniqueStatus[i].status) {
                            case 'ORDERED':
                                orderDate = uniqueStatus[i].date;
                            break;
                            case 'PROCESSED':
                                processDate = uniqueStatus[i].date;
                            break;
                            case 'SHIPPED':
                                shipDate = uniqueStatus[i].date;
                            break;
                            case 'IN_TRANSIT':
                                transitDate = uniqueStatus[i].date;
                            break;
                            case 'DELIVERED':
                                deliverDate = uniqueStatus[i].date;
                            break;
                            default: 'Unknown status';
                        }
                    });
                  	detailsContent +="<div class='accordion-wrapper'>";
                  	var lastStatusNumber = getLastStatusPosition(shippings[shippings.length-1].status);
                  	var trackingNumber = null;
                  	shippings.forEach(function(shipping) {
						trackingNumber = shippings[shippings.length-1].trackingCode != null ? shippings[shippings.length-1].trackingCode : 'A la espera de Número de Seguimiento';
                    });
                    /* Accordion wrapper */
                    detailsContent += "<div class='panel panel-default'>"
                    /* Heading */
                    detailsContent += "<div class='panel-heading' role='tab'>"
                    detailsContent += "<div class='panel-heading-top'>"
                    /* Progress bars */
                    detailsContent += "<div class='prog' data-current-status-index='" + parseInt(lastStatusNumber) + "'>"
                    detailsContent += "<div class='progress_inner'>"
                    detailsContent += "<div class='step'><label data-status='ordered'>Pedido Realizado<span class='fn-date-ordered date'>" + orderDate + "</span></label></div>"
                    detailsContent += "<div class='step'><label data-status='processed'>Procesado<span class='fn-date-ordered date'>" + processDate + "</span></label></div>"
                    detailsContent += "<div class='step'><label data-status='shipped'>Envíado<span class='fn-date-ordered date'>" + shipDate + "</span></label></div>"
                    detailsContent += "<div class='step'><label data-status='in-transit'>En Tránsito<span class='fn-date-ordered date'>" + transitDate + "</span></label></div>"
                    detailsContent += "<div class='step'><label data-status='delivered'>Entregado<span class='fn-date-ordered date'>" + deliverDate + "</span></label></div>"
                    detailsContent += "</div><!-- progress-inner -->"
                    detailsContent += "<div class='progress_inner_bars'>"
                    detailsContent += "<span class='progress_inner_bar'></span><span class='progress_inner__bar--set' style='width: 0' ></span>"
                    detailsContent += "</div><!-- progress-inner-bars -->"
                    /* Progress bars */
                    detailsContent += "<div class='clearfix'></div></div><!-- prog --><div class='clearfix'></div>"
                    detailsContent += "</div><!-- panel-heading-top -->"
                    detailsContent += "<div class='panel-heading-content'>"
                    /* Last status + more info */
                    detailsContent += "<div class='last-status'>"
                    detailsContent += "<div class='last-status-info'>"
                    detailsContent += "<div class='last-status-info-title'>"
                    detailsContent += "<span><span class='text-uppercase status-label'>Número de Seguimiento:</span> " + trackingNumber + "</span>"
                    detailsContent += "</div>"
                    detailsContent += "<div class='last-status-info-title'>"
                    detailsContent += "<span><span class='text-uppercase status-label'>Último estado:</span> " + parseShippingStatus(shippings[shippings.length-1].status) + "</span>"
                    detailsContent += "</div>"
                    detailsContent += "<div class='last-status-info-description'>"
                    detailsContent += "<span class='description'>" + shippings[shippings.length-1].description + "</span>"
                    detailsContent += "<span class='date'>" + formatCompleteDate(shippings[shippings.length-1].lastUpdated) + "</span>"
                    detailsContent += "</div>"
                    detailsContent += "</div>"
                    // More info Button
                    detailsContent += "<div data-toggle='collapse' role='button' href='#track-description-0' aria-controls='track-description-0' class='moreinfo-but' aria-expanded='false'>Ver Detalles<i></i></div>"
                    detailsContent += "</div><div class='clearfix'></div>"
                    detailsContent += "</div><!-- panel-heading-content --></div><!-- panel-heading -->"
                    /* Body */
                    detailsContent += "<div id='track-description-0' class='panel-collapse collapse'>"
                    detailsContent += "<div class='panel-body'>"
                    detailsContent += "<h5 class='current-title'>Detalles</h5>"
                    detailsContent += "<div class='description-line'>"
                    detailsContent += "<ul>"
                    shippings.forEach(function(shipping) {
                      	detailsContent += "<li>"
                        detailsContent += "<span class='current-status-title'><b>" + parseShippingStatus(shipping.status) + "</b></span>";
                        detailsContent += "<span class='current-status-description'>" + shipping.description + "</span>";
                      	if (formatCompleteDate(shipping.lastUpdated)) {
                        	detailsContent += "<span class='current-status-date'>" + formatCompleteDate(shipping.lastUpdated) + "<i class='fa fa-info-circle' data-toggle='tooltip' data-placement='top' title='Esta es la fecha de la actualización de la entrega local'></i></span>";
                        }
                        detailsContent += "</li>"
                    });
                  	detailsContent += "</div>"
                    detailsContent += "</ul>"
                    /* Heading */
                    detailsContent += "</div></div>"
                    /* Accordion wrapper */
                    detailsContent += "</div>"
                  	detailsContent += "</div><!-- Accordion Wrapper -->"
                    $(".loading").hide();
                  	$('.fn-trackingResultsTitle').show();
            		$(".shipping-list-div").html(detailsContent);
                }
            }).error(function() {
          		errorMessage = "Oooops! Algo ha ido mal mientras se procesaba su petición, por favor inténtelo de nuevo más tarde";
              	$(".loading").hide();
          		errorContainer.show();
            });
        } else if(oid && email) {
            var orderId = oid;
            var customerEmail = email;
            var errorMessage = "Oooops! Algo ha ido mal, por favor inténtelo de nuevo más tarde";
            var errorContainer = $('.tracking-wrapper .error');
            var currentStatusDate = "";
            var currentStatusTitle = "";
            var currentStatusDescription = "";
            var detailsContent = "";
            $(errorContainer).hide();
          	$.ajax({
              	async: false,
              	url: "https://gateway.ecommerce-wh.com/suppliers/shippingTrackings/search/timeline?orderId=" + encodeURIComponent(decodeURIComponent(orderId)) +"&customerEmail="+encodeURIComponent(decodeURIComponent(customerEmail))
            }).done(function(data) {
              	var items = data.items;
              	var totalItems = items.length;
              	if (items.length == 0) {
                  	errorMessage = "Oooops! Parece que la dirección no es válida";
                  	errorContainer.show();
                } else {
                  	detailsContent +="<div class='accordion-wrapper'>";
                  	items.forEach(function(item,i) {

                      	if (item.name == 'Donation Default Title') {


                        } else {

                          	console.log(item.name)

                          	if (item.name.includes('Default Title')) {
                              	var itemName = item.name.replace('Default Title', '');
                            } else if (item.name.includes(' null')) {
                              	var itemName = item.name.replace(' null', '');
                            } else {
                              	var itemName = item.name;
                            }

                            var statusDates =  [];

                            item.statusList.forEach(function(shipping) {
                                if (shipping) {
                                    var currentStatus = {};
                                    currentStatus.status = shipping.name;
                                    currentStatus.date = formatSimpleDate(shipping.events[shipping.events.length-1].eventDate);
                                    statusDates.push(currentStatus);
                                }
                            });

                            var uniqueStatus = [];
                            var orderDate = '';
                            var processDate = '';
                            var shipDate = '';
                            var transitDate = '';
                            var deliverDate = '';

                            $.each(statusDates, function (i, e) {
                                var matchingItems = $.grep(uniqueStatus, function (item) {
                                   return item.status === e.status && item.date === e.date;
                                });
                                if (matchingItems.length === 0){
                                    uniqueStatus.push(e);
                                }
                            });

                            $.each(uniqueStatus, function (i, e) {
                                switch(uniqueStatus[i].status) {
                                    case 'ORDERED':
                                        orderDate = uniqueStatus[i].date;
                                    break;
                                    case 'PROCESSED':
                                        processDate = uniqueStatus[i].date;
                                    break;
                                    case 'SHIPPED':
                                        shipDate = uniqueStatus[i].date;
                                    break;
                                    case 'IN_TRANSIT':
                                        transitDate = uniqueStatus[i].date;
                                    break;
                                    case 'DELIVERED':
                                        deliverDate = uniqueStatus[i].date;
                                    break;
                                    default: 'Unknown status';
                                }
                            });

                            /* var to get the Cancellation status of the item */
                            var cancelledItem = item.canceled;

                            var itemImg = item.image != null ? item.image : 'https://d32tjqf3wflmk0.cloudfront.net/web-resources/noimgavailable.png';
                            var trackingNumber = item.trackingNumber != null ? item.trackingNumber : 'Waiting for Tracking Number';
                            var lastStatusNumber = getLastStatusPosition(item.statusList[item.statusList.length-1].name);
                            /* Accordion wrapper */
                            if (cancelledItem) {
                                detailsContent += "<div class='panel panel-default cancelled'>"
                            } else {
                                detailsContent += "<div class='panel panel-default'>"
                            }
                            /* Heading */
                            detailsContent += "<div class='panel-heading' role='tab'>"
                            detailsContent +="<div class='item-counter-wrapper'>Artículo: " + parseInt(i+1) + "/" + totalItems + "</div>";
                            detailsContent += "<div class='panel-heading-top'>"
                            detailsContent += "<div class='item-header'>"
                            //image
                            detailsContent += "<img class='product-thumbnail' src='" + itemImg + "' alt='oredered product image'/>";
                            detailsContent += "<span>" + itemName + "</span>";
                            detailsContent += "</div>"
                            /* Progress bars */
                            detailsContent += "<div class='prog responsive-view-vertical' data-current-status-index='" + parseInt(lastStatusNumber) + "'>"
                            detailsContent += "<div class='progress_inner'>"
                            detailsContent += "<div class='step'><label data-status='ordered'>Pedido Realizado<span class='fn-date-ordered date'>" + orderDate + "</span></label></div>"
                            detailsContent += "<div class='step'><label data-status='processed'>Procesado<span class='fn-date-ordered date'>" + processDate + "</span></label></div>"
                            detailsContent += "<div class='step'><label data-status='shipped'>Envíado<span class='fn-date-ordered date'>" + shipDate + "</span></label></div>"
                            detailsContent += "<div class='step'><label data-status='in-transit'>En Tránsito<span class='fn-date-ordered date'>" + transitDate + "</span></label></div>"
                            detailsContent += "<div class='step'><label data-status='delivered'>Entregado<span class='fn-date-ordered date'>" + deliverDate + "</span></label></div>"
                            detailsContent += "</div><!-- progress-inner -->"
                            detailsContent += "<div class='progress_inner_bars'>"
                            detailsContent += "<span class='progress_inner_bar'></span><span class='progress_inner__bar--set' style='width: 0' ></span>"
                            detailsContent += "</div><!-- progress-inner-bars -->"
                            /* Progress bars */
                            detailsContent += "<div class='clearfix'></div></div><!-- prog --><div class='clearfix'></div>"
                            detailsContent += "</div><!-- panel-heading-top -->"
                            detailsContent += "<div class='panel-heading-content'>"
                            /* Last status + more info */
                            detailsContent += "<div class='last-status'>"
                            detailsContent += "<div class='last-status-info'>"
                            detailsContent += "<div class='last-status-info-title'>"
                            detailsContent += "<span><span class='text-uppercase status-label'>Número de Seguimiento:</span> " + trackingNumber + "</span>"
                            detailsContent += "</div>"
                            detailsContent += "<div class='last-status-info-title'>"
                            detailsContent += "<span><span class='text-uppercase status-label'>Último Estado:</span> " + parseShippingStatus(item.statusList[item.statusList.length-1].name) + "</span>"
                            detailsContent += "</div>"
                            detailsContent += "<div class='last-status-info-description'>"
                            detailsContent += "<span class='description'>" + item.statusList[item.statusList.length-1].events[item.statusList[item.statusList.length-1].events.length -1].description + "</span>"
                            detailsContent += "<span class='date'>" + formatCompleteDate(item.statusList[item.statusList.length-1].events[item.statusList[item.statusList.length-1].events.length -1].eventDate) + "</span>"
                            detailsContent += "</div>"
                            detailsContent += "</div>"
                            // More info Button
                            detailsContent += "<div data-toggle='collapse' role='button' href='#track-description-" + i +"' aria-controls='track-description-" + i + "' class='moreinfo-but' aria-expanded='false'>Ver Detalles <i></i></div>"
                            detailsContent += "</div><div class='clearfix'></div>"
                            detailsContent += "</div><!-- panel-heading-content -->"
                            /* Headings */
                            detailsContent += "</div>"
                            /* Body */
                            detailsContent += "<div id='track-description-" + i + "' class='panel-collapse collapse'>"
                            detailsContent += "<div class='panel-body'>"
                            detailsContent += "<h5 class='current-title'>Detalles</h5>"
                            //Description
                            item.statusList.forEach(function(itemStatus) {
                                detailsContent += "<div class='description-line'>"
                                detailsContent += "<ul>"
                                itemStatus.events.forEach(function(statusEvents) {
                                    detailsContent += "<li>"
                                    detailsContent += "<span class='current-status-title'><b>" + parseShippingStatus(itemStatus.name) + "</b></span>";
                                    detailsContent += "<span class='current-status-description'>" + statusEvents.description + "</span>";
                                    detailsContent += "<span class='current-status-date'>" + formatCompleteDate(statusEvents.eventDate) + "<i class='fa fa-info-circle' data-toggle='tooltip' data-placement='top' title='Esta es la fecha de la actualización de la entrega local'></i></span>";
                                    detailsContent += "</li>"
                                });
                                detailsContent += "</ul>"
                                detailsContent += "</div>"
                            });
                            /* Body */
                            detailsContent += "</div></div>"
                            /* Accordion wrapper */
                            detailsContent += "</div>";
                        }
                	});
                	/* Accordion wrapper */
                	detailsContent += "</div>";
            	}
            }).error(function() {
                errorMessage = "Oooops! Algo ha ido mal mientras se procesaba su petición, por favor inténtelo de nuevo más tarde";
              	$(".loading").hide();
                errorContainer.show();
            });
          	$(".loading").hide();
          	$('.fn-trackingResultsTitle').show();
          	$(".shipping-list-div").html(detailsContent);
      	} else {
          	$(".loading").hide();
			$('#trackOrderForm').show();
        }
      	/* Country Delivery Company Events */
      	$('.country-switcher').click(function(){
			$(this).toggleClass('open');
		});
        $('.option').click(function() {
          	var optionCountryCode = $(this).attr('data-value');
          	updateCountrySelect(optionCountryCode);
          	updateCompanyLinksByCountry(optionCountryCode.toLowerCase());
        });
      	var checkIpCode = setInterval(function() {
        	if (window.countryCode) {
                clearInterval(checkIpCode);
                updateCountrySelect(window.countryCode);
                updateCompanyLinksByCountry(window.countryCode.toLowerCase());
          	}
      	}, 1000);
    });
})(jQuery, window);